import { ActionRegistryCategory } from '../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../registry/action/ActionRegistryItem';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
export class ActionsChoiceOption extends ActionRegistryCategory {
    label = 'ChoiceOption';
    constructor(parent) {
        super(parent);
        super.init();
    }
    selectOption = () => new ActionRegistryItem({
        label: 'Option auswählen',
        action: ({ question, option, event, e }) => {
            if (!question || !option)
                return;
            // alert(334);
            if (!question.choiceEval.isComplete) {
                option.selectOption({ event });
                if (e)
                    e.stopPropagation();
                if (document.activeElement instanceof HTMLElement)
                    document.activeElement.blur();
                setTimeout(() => option.actorEvents.fireEvent({ type: 'optionwasselected' }));
            }
        },
    });
    preselectOptionByKeyboard = () => new ActionRegistryItem({
        label: 'Option vorauswählen (Pfeiltasten)',
        action: ({ question, event }) => {
            if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key) &&
                question &&
                question.questionType === QuestionTypeName.MultipleChoice) {
                question.choiceKeyboardSelect.handleArrowKeyPress(event.key);
            }
        },
    });
    resetKeyboardOption = () => new ActionRegistryItem({
        label: 'setze Keyboard Option zurück',
        action: ({ question, event }) => (question.choiceKeyboardSelect.keyboardOption = undefined),
    });
}
